/**
 * The task kind's guard — `EntrySlice.guard`, once the registry (#312) binds it.
 *
 * The one guard of the eight that already had a call site (#359): `EntryRow.tsx:71`, in the person
 * slice's timeline.
 */

import type { Entry } from '@/document'
import type { TaskEntry } from './meta'

export function isTaskEntry(entry: Entry): entry is TaskEntry {
  return entry.type === 'task'
}
